import { objectValues } from '../utils';

export const TREE_EVENT = {
  EXPAND: 'tree:expand',
  COLLAPSE: 'tree:collapse',
  SEARCH: 'tree:search',
  SEARCH_OPEN: 'tree:search-open',
  SEARCH_CLOSE: 'tree:search-close',
  SHOW_INFO: 'tree:show-info',
  CLOSE_INFO: 'tree:close-info',
  CHANGE_DATE: 'tree:change-date'
}
export const TREE_EVENTS = objectValues(TREE_EVENT);

export const INFO_EVENT = {
  EXPAND: 'info:expand',
  COLLAPSE: 'info:collapse',
  CHANGE_DATE: 'info:change-date'
}
export const INFO_EVENTS = objectValues(INFO_EVENT);

export const MANAGER_EVENT = {
  REGISTER_ORIGIN: 'manager:register-origin'
}
export const MANAGER_EVENTS = objectValues(MANAGER_EVENT);

export const IPC_EVENTS = [].concat(TREE_EVENTS).concat(INFO_EVENTS).concat(MANAGER_EVENTS);

export const TREE_GROUP_HANDLERS = {
  [TREE_EVENT.EXPAND]: function({ expanded }) { this.setOptions({ expanded }); },
  [TREE_EVENT.COLLAPSE]: function({ expanded }) { this.setOptions({ expanded }); },
  [TREE_EVENT.SHOW_INFO]: function({ code }) { this.setOptions({ 'info-code': code }) },
  [TREE_EVENT.CLOSE_INFO]: function() { this.setOptions({ 'info-code': null }) },
  [TREE_EVENT.CHANGE_DATE]: function({ date }) { this.setOptions({ date }) },
  [TREE_EVENT.SEARCH_OPEN]: function() { this.setOptions({ 'search-open': true }) },
  [TREE_EVENT.SEARCH_CLOSE]: function() { this.setOptions({ 'search-open': null }) },
  [TREE_EVENT.SEARCH]: function({ searchTerm }) { this.setOptions({ 'search-term': searchTerm }) },
  [INFO_EVENT.CHANGE_DATE]: function({ date }) { this.setOptions({ date }) }
}

export const INFO_GROUP_HANDLERS = {
  [TREE_EVENT.EXPAND]: function({ code }) { code && this.setOptions({ code }) },
  [TREE_EVENT.COLLAPSE]: function({ code }) { code && this.setOptions({ code }) },
  [TREE_EVENT.SHOW_INFO]: function({ code }) { code && this.setOptions({ code }) },
  [TREE_EVENT.CHANGE_DATE]: function({ date }) { this.setOptions({ date }) },
  [INFO_EVENT.CHANGE_DATE]: function({ date }) { this.setOptions({ date }) }
}

export const GROUP_HANDLERS = {
  tree: TREE_GROUP_HANDLERS,
  info: INFO_GROUP_HANDLERS
}



// WEBPACK FOOTER //
// ./src/shared/dictionaries/events.js